<template>
  <div class="login-container">
    <div class="login-form-container">
      <h3>Login</h3>
      <form @submit.prevent="login">
        <input type="email" class="form-control" v-model="email" placeholder="Email" required>
        <input type="password" class="form-control" v-model="password" placeholder="Password" required>
        <button type="submit" class="btn login-btn" :disabled="loading">
          {{ loading ? "Logging in..." : "Login" }}
        </button>
        <p v-if="errorMessage" class="error-message">{{ errorMessage }}</p>
        <router-link to="/forgot-password" class="forgot-password">Forgot Password?</router-link>
      </form>
    </div>
  </div>
</template>

<script>
// import { useStore } from 'vuex';
// import { useRouter } from 'vue-router';

export default {
  data() {
    return {
      email: '',
      password: '',
      loading: false,
      errorMessage: null
    };
  },
  methods: {
    async login() {
      this.loading = true;
      this.errorMessage = null;
      const success = await this.$store.dispatch('login', { email: this.email, password: this.password });
      if (success) {
        // console.log(this.$store.getters.getUser.role);
        // if (this.$store.getters.getUser.role == 'counselor') {
        //   this.$router.push('/dashboard/attendance');
        // }
        // else {
        this.$router.push('/dashboard'); // Redirect to Dashboard on success
        // }

      } else {
        this.errorMessage = "Invalid credentials";
      }
      this.loading = false;
    }
  },
  mounted() {
    console.log("Login component mounted");
  }
};
</script>

<style scoped>
.login-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-color: #e6f6ff;
}

.login-form-container {
  background: white;
  padding: 30px;
  max-width: 400px;
  width: 100%;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.login-form-container h3 {
  margin-bottom: 20px;
  border-bottom: 2px solid #1DBCBC;
  text-align: left;
  padding-bottom: 10px;
}

.login-form-container input {
  width: 100%;
  padding: 12px;
  margin: 10px 0;
  border: 1px solid #ccc;
  border-radius: 5px;
}

.login-btn {
  background-color: #1DBCBC;
  color: white;
  padding: 12px;
  width: 100%;
  border: none;
  border-radius: 5px;
  font-size: 16px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.login-btn:hover {
  background-color: #18a2a2;
}

.forgot-password {
  display: block;
  margin-top: 10px;
  text-decoration: none;
  color: #222250;
  font-size: 14px;
  text-align: center;
}
</style>
